import NewWellSubmissionWrapped from '../../../../components/wells/submission'

export default function EditSubmissionPage() {
  return <NewWellSubmissionWrapped isEditMode />
}
